// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UJpIA","placeholdersHeader":"styles_placeholdersHeader__DQLDE","editorStyle":"styles_editorStyle__2uqW-","placeholdersBox":"styles_placeholdersBox__3hIEr"};